export default (language, directory, image) => `/static/images/${directory}/${image[language]}`;
